import {HeartIcon as SolidHeartIcon} from "@heroicons/react/24/solid";
import {HeartIcon as OutlineHeartIcon} from "@heroicons/react/24/outline";
import React from "react";
import {axiosInstance} from "../../Api/AxiosConfig";

export const LikeCar = ({car, fnAfterUpdate, iconSize = "w-4 h-4"}) => {

    const addLike = (hash) => {
        axiosInstance
            .post("shop/like", {hash: hash})

            .then(() => {
                fnAfterUpdate();
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }

    const removeLike = (hash) => {
        console.log('removeLike', hash);
        axiosInstance
            .delete("shop/like", {data: {hash: hash}})

            .then(() => {
                fnAfterUpdate();
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }

    return (
        <>
            {car.like &&
                <div className="flex items-center justify-center" onClick={(e) => {
                    e.stopPropagation();
                    removeLike(car.hash)
                }}><SolidHeartIcon className={`${iconSize} text-gray-400`}/></div>
            }
            {!car.like &&
                <div className="flex items-center justify-center" onClick={(e) => {
                    e.stopPropagation();
                    addLike(car.hash)
                }}><OutlineHeartIcon className={`${iconSize} text-primary-color`}/></div>
            }
        </>
    )

}